import _objectSpread from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import router from '@/router';
import store from '@/store';
import { registerMicroApps } from 'qiankun';
import { UMENGEventId } from './utils/umeng';
import { version } from '../package.json';
import { ProdStaticUrl, ProductionUrl } from '@/utils/request';
import { CURRENT_SECONDARY_BRAND } from '@/config';
import bridgeApp from '@/utils/app';
import Utils from '@/utils/utils';
var VUE_APP_ENV = process.env.VUE_APP_ENV;
var brand = CURRENT_SECONDARY_BRAND ? "//".concat(CURRENT_SECONDARY_BRAND.microHost, "/") : '//localhost:3000/'; // 开发环境 本地开发使用 //localhost:3000/

var development = {
  brand: brand
}; // 测试环境 本地开发使用 //localhost:3000/
// const test = { brand: '//192.168.110.36:3000/' }

var test = {
  brand: brand
}; // 预发布

var realpre = {
  brand: brand
}; // 生成环境

var production = {
  brand: brand
}; // 生成入口地址

var entryType = {
  development: development,
  realpre: realpre,
  test: test,
  production: production
}[VUE_APP_ENV]; // 生成子应用入口

export var microAppList = Object.keys(entryType).map(function (name) {
  return {
    name: name,
    // 应用名称
    entry: entryType[name],
    // 入口 || 访问地址
    container: '#microApp',
    // 子应用所在容器(div)
    activeRule: "/".concat(name),
    // 子应用触发规则（路径）
    props: {
      router: router,
      store: store,
      UMENGEventId: UMENGEventId,
      CURRENT_SECONDARY_BRAND: CURRENT_SECONDARY_BRAND,
      version: version,
      api: {
        ProductionUrl: ProductionUrl,
        ProdStaticUrl: ProdStaticUrl
      },
      bridgeApp: _objectSpread(_objectSpread({}, bridgeApp), {}, {
        appInfo: Utils.appInfo
      })
    } // 额外传递给子应用的参数

  };
}); // 注册子应用

registerMicroApps(microAppList); // 开启服务
// start()